import React, { useEffect, useRef } from "react";
import { isWeb } from "../platform";
import { fontFacesCSS } from "./fontFaces";

let injected = false;

/**
 * Injects @font-face declarations into the document on web.
 * Safe to render multiple times — the style tag is only created once.
 * No-ops on React Native.
 */
function injectFontStyles(): void {
  if (!isWeb || injected) return;

  const style = document.createElement("style");
  style.setAttribute("data-xui-fonts", "");
  style.textContent = fontFacesCSS;
  document.head.appendChild(style);
  injected = true;
}

/**
 * React component that loads the toolkit's font-face declarations.
 * Drop-in for any framework — works in Next.js, Vite, CRA, etc.
 *
 * Renders nothing to the DOM. Injects a single `<style>` tag into `<head>` on mount.
 */
export const FontLoader: React.FC = () => {
  const mountedRef = useRef(false);

  useEffect(() => {
    if (!mountedRef.current) {
      injectFontStyles();
      mountedRef.current = true;
    }
  }, []);

  return null;
};

FontLoader.displayName = "FontLoader";
